export const state = () => ({
	//
});

export const mutations = {
	//
};

export const getters = {
	//
};

export const actions = {
	getEmployerDocumentUrl(state: any, documentUuid: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/employer/documents/${documentUuid}`)
				.then((res) => resolve(res.data))
				.catch((err) => reject(err));
		});
	},
};
